<template>
<q-card class="fit bg-grey-3">
  <q-card-section class="bg-eng text-white">
    <div class="text-subtitle2 text-bold text-center">We'll contact you!</div>
  </q-card-section>
  <q-separator />
  <q-card-section>
    <div class="row">
      <q-input v-model="conData.name"
               outlined
               dense
               autofocus
               no-error-icon
               ref="name"
               bg-color="white"
               :rules="reqRules"
               maxlength="40"
               class="full-width"
               label="Name" />
    </div>
    <div class="row">
      <q-input v-model="conData.cell"
               outlined
               dense
               no-error-icon
               ref="cell"
               unmasked-value
               bg-color="white"
               mask="phone"
               :rules="cellRules"
               class="full-width"
               label="Cell #" />
    </div>
    <div class="row"
         v-show="$route.params.mso_id != 0">
      <q-select v-model="conData.location_id"
                label="Location"
                no-error-icon
                ref="shop"
                bg-color="white"
                :options="shopOptions"
                outlined
                emit-value
                map-options
                option-value="location_id"
                option-label="name"
                dense
                :rules="reqRules"
                class="full-width">
        <template slot="selected-item"
                  slot-scope="data">
          <div class="ellipsis">{{ data.opt.name }}</div>
        </template>
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-grey">
              No locations found
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="row">
      <q-input v-model="conData.message"
               outlined
               dense
               hide-bottom-space
               type="textarea"
               no-error-icon
               maxlength="1500"
               label="Message"
               ref="message"
               no-resize
               rows="4"
               bg-color="white"
               :rules="reqRules"
               :input-style="{ resize: 'none' }"
               class="full-width" />
    </div>
    <div class="row justify-center q-pa-sm">
      <span style="font-size: 11px;opacity: 0.4">Messaging and data rates apply.</span>
    </div>
    <div class="row justify-center">
      <q-btn :loading="contactMeLoading"
             color="eng"
             @click="contactMe()">
        <template v-slot:loading>
          <q-spinner-comment color="primary"
                             size="27px" />
        </template> Send
      </q-btn>
    </div>
  </q-card-section>
  <div id="footer"
       class="row justify-center q-pb-sm cursor-pointer"
       style="opacity: 0.4"
       @mouseover="hover(true)"
       @mouseout="hover(false)"
       @click="popEngage()">
    <img height="18"
         src="https://engagesms.net/app/images/icon.png">
    <span class="q-ml-xs"
          style="font-size: 11px">Powered by Engage</span>
  </div>
</q-card>
</template>

<script>
export default {
  name: 'Form',

  created() {
    if (this.$route.params.mso_id != 0) this.loadShops()
  },

  data() {
    return {
      conData: {
        name: null,
        cell: null,
        location_id: this.$route.params.location_id ? parseInt(this.$route.params.location_id) : null,
        message: null
      },
      contactMeLoading: false,
      shopOptions: [],
      cellRules: [v => !!v || '', v => (v && v.length == 10) || '', v => (v && !isNaN(v)) || ''],
      reqRules: [v => !!v || '']
    }
  },

  methods: {
    hover(which) {
      which
        ?
        (document.getElementById('footer').style.opacity = 1.0) :
        (document.getElementById('footer').style.opacity = 0.4)
    },

    popEngage() {
      window.open('https://www.engagesms.net', '_blank')
    },

    loadShops() {
      this.$axios
        .get('msoLocations', {
          params: {
            msoKey: this.$route.params.mso_id
          }
        })
        .then(response => {
          this.shopOptions = Object.values(response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },

    contactMe() {
      this.$refs.name.validate()
      this.$refs.cell.validate()
      if (this.$route.params.mso_id != 0) this.$refs.shop.validate()
      this.$refs.message.validate()

      if (
        !this.$refs.name.hasError &&
        !this.$refs.cell.hasError &&
        !this.$refs.shop.hasError &&
        !this.$refs.message.hasError
      ) {
        this.contactMeLoading = true

        this.$axios
          .post('contactMe', {
            conData: this.conData
          })
          .then(response => {
            this.contactMeLoading = false
            this.$emit('closeMenu')
          })
          .catch(error => {
            this.contactMeLoading = false
            console.log(error)
          })
      }
    }
  }
}
</script>
